import { IProgressIndicatorProps, ProgressIndicator } from '@fluentui/react/lib/ProgressIndicator';

export interface IPProgressIndicatorProps extends IProgressIndicatorProps {}

export const IPProgressIndicator = (props: IPProgressIndicatorProps) => {
  return <ProgressIndicator {...props} />;
};
